/** The separate maps the Map tab draws, one per tab, in tab order. */
export const CHINA_MAP_REGION_IDS = [
  "mainland",
  "taiwan",
  "hong-kong",
  "macau",
  "singapore",
] as const;

export type ChinaMapRegionId = (typeof CHINA_MAP_REGION_IDS)[number];

/**
 * Maps whose places are labeled in traditional characters even for a simplified-curriculum user.
 * Taiwan, Hong Kong and Macau write in traditional Chinese; mainland and Singapore do not.
 */
export const CHINA_MAP_TRADITIONAL_LABEL_REGION_IDS = [
  "taiwan",
  "hong-kong",
  "macau",
] as const satisfies readonly ChinaMapRegionId[];

export type ChinaMapTraditionalLabelRegionId =
  (typeof CHINA_MAP_TRADITIONAL_LABEL_REGION_IDS)[number];

export function isChinaMapTraditionalLabelRegion(
  regionId: ChinaMapRegionId,
): regionId is ChinaMapTraditionalLabelRegionId {
  return (CHINA_MAP_TRADITIONAL_LABEL_REGION_IDS as readonly ChinaMapRegionId[]).includes(regionId);
}
